/**
 * Generic utility for updating data
 */

export function map(list, fn, scope) {
  let copy = []
  let dirty = false

  copy.length = list.length

  for (var i = 0, len = list.length; i < len; i++) {
    let last = list[i]
    let next = fn.call(scope, last, i)

    if (next !== last) {
      dirty = true
    }

    copy[i] = next
  }

  return dirty ? copy : list
}



// WEBPACK FOOTER //
// ./src/update.js